import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeURL'
})
export class PageViewerSafeUrlPipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) {}

  public transform(htmlString: string): any {
    return this.sanitizer.bypassSecurityTrustHtml(htmlString);
  }
}
